module.exports = __webpack_public_path__ + "img/ennetix-class-rules-table.d4ea3aa2.png";